import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers';
import { ReportGeneration } from 'Common/ObjectHelper';
import { createToast, toastType } from 'Common/ToastHelper';
import ItemSummaryForm from './components/ItemSummaryForm';
import { getReport, clearReport } from './state/actions';
import { itemSummaryInitialValues } from './helpers/ItemSummaryObjects';
import { ITEM_SUMMARY_FORM_NAME } from 'Common/FormEnum';

class ItemSummaryContainer extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.report !== '' && prevProps.report === '') {
      if (this.props.report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(this.props.report, 'Item Summary Report');
      }

      this.props.clearReport();
    }
  }

  submitForm = values => {
    this.props.getReport(values);
  };

  getMainProps = () => {
    const { isFetching } = this.props;

    return {
      toolbox: {
        formName: ITEM_SUMMARY_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: isFetching,
          disabled: isFetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const { isFetching } = this.props;

    return (
      <Fragment>
        <Filter title="Item Summary" />
        <Main {...this.getMainProps()}>
          <ItemSummaryForm
            onSubmit={this.submitForm}
            initialValues={itemSummaryInitialValues()}
            isFetching={isFetching}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    report: state.ItemSummaryState.report,
    isFetching: state.ItemSummaryState.isFetching,
  };
};

export const ItemSummary = withRouter(
  connect(
    mapStateToProps,
    { getReport, clearReport }
  )(ItemSummaryContainer)
);



// WEBPACK FOOTER //
// ./src/pages/itemsummary/ItemSummary.js